import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { PackageActionType } from '~/actions/packageActions';
import { activityTemplateService } from '~/services/activityTemplateAPI';
import { useCurrentWorkspaceQueryKey } from '../utils';
import { getTaskPackageQueryKey } from '../activity';

interface Options {
  robotId: string;
  gitUrl: string;
}

export const useLinkGitSourceMutation = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { queryKeyFormatter, workspaceId } = useCurrentWorkspaceQueryKey();

  return useMutation(
    async ({ robotId, gitUrl }: Options) => {
      const response = await activityTemplateService.handleGitRobot({
        workspaceId,
        id: robotId,
        url: gitUrl,
      });
      if (!response.ok) {
        dispatch({
          type: PackageActionType.HANDLE_GIT_ROBOT_ERROR,
          error: response.problem,
          subCode: response.data?.error?.subCode,
          id: robotId,
        });
        throw new Error(response.problem);
      }

      return response.data;
    },
    {
      onSuccess: (_, { robotId }) => {
        queryClient.invalidateQueries(queryKeyFormatter(getTaskPackageQueryKey(robotId)));
      },
    },
  );
};
